// extracted by mini-css-extract-plugin
export default {"banner":"styles_banner__xAiuQ","message":"styles_message__vac01"};